export class Invite {
    constructor() {
        this.status = 3
        this.waitOnLobby = true;
    }
    id: string;
    invitionId: string;
    inviteDescription: string;
    numberOfInvitations: number;
    remainingInvitations: number;
    typeCard: number;
    buildingKey: string;
    authorizationId: number;
    authorizedByUserId: number;
    authorizedByUserName: string;
    residenceId: number;
    companyId: number;
    visitorUserId: number;
    visitorDocumentType: string;
    visitorDocument: string;
    visitorName: string;
    visitorVehicleEnabled: string;
    visitorVehiclePlate: string;
    validPeriodStartsAt: string;
    validPeriodEndsAt: string;
    comments: string;
    serviceProvider: boolean;
    onlyOperatorReleases: boolean;
    waitOnLobby: boolean;
    singleAccess: boolean;
    reasonToRefuse: string;
    status: number;
    unitOwner: boolean;
    canAllowVisitors: boolean;
}
